import { getProjectsAction } from '../redux/Reducers/projectsReducer';
import { BASE_URL } from './BASE_URL';

export const getProjects = () => {
  return async (dispatch) => {
    const response = await fetch(BASE_URL + 'projects/?limit=550');
    const data = await response.json();

    if (response.status === 200) {
      dispatch(getProjectsAction(data));
    }
  };
};
